import { render, staticRenderFns } from "./RowItemInventory.vue?vue&type=template&id=55d21646&scoped=true&"
import script from "./RowItemInventory.vue?vue&type=script&lang=js&"
export * from "./RowItemInventory.vue?vue&type=script&lang=js&"
import style0 from "./RowItemInventory.vue?vue&type=style&index=0&id=55d21646&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d21646",
  null
  
)

export default component.exports